import React from "react";
import styles from './index.module.css';

const Footer = () => {
    return (
      <footer className={styles.footerSec}>
           <div className={styles.footer}>
            Copyright © {new Date().getFullYear()}{" "} IBS
          </div>
      </footer>
    );
  };
  
  export default Footer;